import React, { useState } from "react";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";

import CNDCadastro from "../CNDCadastro";
import CNDTabControle from "../CNDTabControle";
import "../CND.css";

export default function CNDStepper({ open, setOpen }) {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      title: "Cadastro de CND",
      label: "Cadastre uma CND automática ou manual",
    },
    {
      title: "Painel de Controle de CND",
      label:
        "Aguarde, confira e controle o resultado da consulta automática ou insira um anexo com as informações da CND manual",
    },
  ];

  const handleNext = () => {
    if (activeStep + 1 === steps.length) setOpen(false);

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const telas = [
    <CNDCadastro withoutModal={true} nextStepper={handleNext} />,
    <CNDTabControle rowsPerPage={1} />,
  ];

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className="modal"
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Typography
          className="stepper-typography"
          variant={"body1"}
          component={"div"}
        >
          <div className="container-stepper">
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((step, index) => (
                <Step key={index}>
                  <StepLabel>
                    <label className="stepper-title">{step.title}</label>
                    {step.label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            <div className="stepper-container-screen">{telas[activeStep]}</div>
          </div>
          <div>
            <div>
              <div className="margin-left-20">
                <Button disabled={activeStep === 0} onClick={handleBack}>
                  Voltar
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                >
                  {activeStep === steps.length - 1 ? "Finalizar" : "Próximo"}
                </Button>
              </div>
            </div>
          </div>
        </Typography>
      </Fade>
    </Modal>
  );
}
